function addClass(obj, cls) {
    if (!hasClass(obj, cls)) obj.className += " " + cls;
  }
  function  toggleClass(obj,cls){
    if(hasClass(obj,cls)){
      removeClass(obj, cls);
    }else{
      addClass(obj, cls);
    }
  }
  function  removeClass(obj, cls) {
    if (hasClass(obj, cls)) {
      var reg = new RegExp('(\\s|^)' + cls + '(\\s|$)');
      obj.className = obj.className.replace(reg, ' ');
    }
  }
  function hasClass(obj, cls) {
    return obj.className.match(new RegExp('(\\s|^)' + cls + '(\\s|$)'));
  }
  const consoleFu={
    addClass:addClass,
toggleClass:toggleClass,
removeClass:removeClass,
hasClass:hasClass,
  }
  export default consoleFu